module.exports = __webpack_public_path__ + "img/colaboration-of-dama.ecb8b476.png";